import PropTypes from 'prop-types'
import './styles.css'
import { useAppSelector } from '@hooks/store'

const ComprobantDetailPaymentBodyBill = ({ detailPaymentData }) => {
  const { currencySymbol } = useAppSelector(state => state.auth)
  return (
    <div className='comprobant-detail-payment-body-bill'>
      <span>Detalle de cobro</span>
      <div className='comprobant-detail-payment-body-bill-grid'>
        {
          detailPaymentData?.details?.map((item, index) => ({ ...item, key: index })).map((item) => (
            <div className='comprobant-detail-payment-body-bill-grid-item' key={item.key}>
              <span className='comprobant-detail-payment-body-bill-grid-item-name'>{item.name}</span>
              <span className='comprobant-detail-payment-body-bill-grid-item-total'>
                {currencySymbol} {(item.total ?? 0)?.toFixed(2)}
              </span>
            </div>
          ))
        }
      </div>
      <div className='comprobant-detail-payment-body-bill-grid'>
        {
          detailPaymentData?.taxes?.map((item, index) => ({ ...item, key: index })).map((item) => (
            <div className='comprobant-detail-payment-body-bill-grid-item' key={item.key}>
              <span className='comprobant-detail-payment-body-bill-grid-item-name'>{item.name}</span>
              <span className='comprobant-detail-payment-body-bill-grid-item-total'>
                {currencySymbol} {(item.total ?? 0)?.toFixed(2)}
              </span>
            </div>
          ))
        }
      </div>
      <div className='comprobant-detail-payment-body-bill-grid total'>
        <div className='comprobant-detail-payment-body-bill-grid-item'>
          <span className='comprobant-detail-payment-body-bill-grid-item-name'>Monto gravable</span>
          <span className='comprobant-detail-payment-body-bill-grid-item-total'>
            {currencySymbol} {(detailPaymentData?.totals?.total ?? 0)?.toFixed(2)}
          </span>
        </div>
        <div className='comprobant-detail-payment-body-bill-grid-item'>
          <span className='comprobant-detail-payment-body-bill-grid-item-name'>Total de impuestos</span>
          <span className='comprobant-detail-payment-body-bill-grid-item-total'>
            {currencySymbol} {(detailPaymentData?.totals?.taxable_total ?? 0)?.toFixed(2)}
          </span>
        </div>
        <div className='comprobant-detail-payment-body-bill-grid-item'>
          <span className='comprobant-detail-payment-body-bill-grid-item-name'>Total</span>
          <span className='comprobant-detail-payment-body-bill-grid-item-total full'>
            {currencySymbol} {(detailPaymentData?.totals?.total ?? 0)?.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  )
}

ComprobantDetailPaymentBodyBill.propTypes = {
  detailPaymentData: PropTypes.object
}

export default ComprobantDetailPaymentBodyBill
